import { VendedorPolicy } from "./VendedorPolicy";

export const vendedorPolicy = new VendedorPolicy()